/**
 * Phone-number display helpers (Daniel 2026-06-06).
 *
 * Agents copy/paste phone numbers from TR into texts, dialers, and CRMs
 * all day long. Dash-separated formatting (316-364-7500) is the most
 * forgiving — every system accepts it, and the dashes make it readable.
 *
 * `formatPhone` always returns a display-only string. The DB still
 * stores whatever raw value the agent typed; we never round-trip
 * formatted strings back into storage.
 */

/**
 * Format a raw phone string as "XXX-XXX-XXXX" when it's a US 10-digit
 * number, or "1-XXX-XXX-XXXX" when prefixed with a 1. Returns the
 * original string untouched for anything else (international, short
 * codes, garbage) so we never lose information the agent needs to see.
 */
export function formatPhone(raw: string | null | undefined): string {
  if (raw == null) return '';
  const digits = raw.replace(/\D/g, '');
  if (digits.length === 10) {
    return `${digits.slice(0, 3)}-${digits.slice(3, 6)}-${digits.slice(6)}`;
  }
  if (digits.length === 11 && digits.startsWith('1')) {
    return `1-${digits.slice(1, 4)}-${digits.slice(4, 7)}-${digits.slice(7)}`;
  }
  // International / extension / partial entry — leave alone so the
  // agent sees what they entered.
  return raw;
}
